export default __webpack_public_path__ + "static/media/fMaltoBuza16.c94e9597.png";